import type { ActiveFeatureConfigAction } from './types';

export const activeFeatureConfigInitial = {};
export enum ContextAction {
  setActiveFeatureConfig = 'SET_ACTIVE_FEATURE_CONFIG'
}
export type ActiveFeatureConfigState = Record<string, boolean>;

export const activeFeatureConfigReducer = (
  state: ActiveFeatureConfigState,
  action: ActiveFeatureConfigAction
): ActiveFeatureConfigState => {
  switch (action.type) {
    case ContextAction.setActiveFeatureConfig:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
